import { render } from "./DetailsSection.vue?vue&type=template&id=5c603dbe&scoped=true"
import script from "./DetailsSection.js?vue&type=script&lang=js"
export * from "./DetailsSection.js?vue&type=script&lang=js"

import "./DetailsSection.scss?vue&type=style&index=0&id=5c603dbe&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./DetailsSection.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FPageProductDetail%2FProductInfo%2FDetailsSection%2FDetailsSection.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c603dbe"]])

export default __exports__